<div class="filter-container" #filterContainer>
  <button class="static-button action-button tableActions position-relative" mat-mini-fab matTooltip="Filters" matTooltipClass="table-header-tooltip"
    (click)="filterClickHandler($event)">
    <i class="fas fa-filter fa-2x"></i>
    @if (noOfFilters) {
      <span class="filter-count">{{ noOfFilters }}</span>
    }
  </button>

  @if (isClicked) {
    <div class="filter-menu-container">
      <div (click)="containerHandler($event)">
        <div class="row">
          <div class="col-4 border-right pl-3 pr-0 pt-0 pb-0" style="height: 100%">
            <div class="option-col">
              @for (filter of filterData; track filter; let i = $index) {
                <div>
                  <div class="filter-option mb-1" (mouseover)="hoverActive = true; itemIndex = i"
                (mouseout)="hoverActive = false; itemIndex = -1" [ngStyle]="
                  ((hoverActive && i === itemIndex) ||
                    filter.name === selectedItem.name ||
                    isFilterApplied(filter)) && {
                      'background-color': 'palegreen'
                    }
                " (click)="toggleDropdown(filter, i)">
                  {{ filter.name }}
                </div>
              </div>
            }
          </div>
        </div>
        <div class="col-7">
          @switch (selectedItem.type) {
            @case ('impression_count') {
              <div class="p-2">
                <form [formGroup]="filterForm" (click)="handleMaterialClick($event)">
                  <p class="mb-2">{{ selectedItem?.name || 'Impression Count Filter' }}</p>
                  <!-- Operator Selection -->
                  <mat-form-field appearance="outline" class="w-100 mb-3" (click)="handleMaterialClick($event)">
                    <mat-label>Operator</mat-label>
                    <mat-select [formControl]="getCurrentImpressionCountControl()?.get('operator')"
                      (click)="handleMaterialClick($event)">
                      @for (op of impressionCountOperators; track op) {
                        <mat-option [value]="op.value"
                          (click)="handleMaterialClick($event)">
                          {{ op.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <!-- Single Value Input -->
                  @if (!isImpressionCountBetweenOperator()) {
                    <div class="mb-3" (click)="handleMaterialClick($event)">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Impression Count</mat-label>
                        <input matInput type="number" [formControl]="getCurrentImpressionCountControl()?.get('value')"
                          placeholder="Enter impression count" min="0" (click)="handleMaterialClick($event)" />
                        </mat-form-field>
                      </div>
                    }
                    <!-- Range Inputs for Between Operator -->
                    @if (isImpressionCountBetweenOperator()) {
                      <div class="mb-3" (click)="handleMaterialClick($event)">
                        <div class="row">
                          <div class="col-6">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-label>From Count</mat-label>
                              <input matInput type="number" [formControl]="getCurrentImpressionCountControl()?.get('start')"
                                placeholder="Min" min="0" (click)="handleMaterialClick($event)" />
                              </mat-form-field>
                            </div>
                            <div class="col-6">
                              <mat-form-field appearance="outline" class="w-100">
                                <mat-label>To Count</mat-label>
                                <input matInput type="number" [formControl]="getCurrentImpressionCountControl()?.get('end')"
                                  placeholder="Max" min="0" (click)="handleMaterialClick($event)" />
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        }
                        <!-- Action Buttons-->
                        <div class="mt-3">
                          <ng-template [ngTemplateOutlet]="Actions"
                          [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                        </div>
                      </form>
                    </div>
                  }
                  @case ('pass_percentage') {
                    <div class="p-2">
                      <form [formGroup]="filterForm" (click)="handleMaterialClick($event)">
                        <p class="mb-2">{{ selectedItem?.name || 'Pass Percentage Filter' }}</p>
                        <mat-form-field appearance="outline" class="w-100 mb-3" (click)="handleMaterialClick($event)">
                          <mat-label>Operator</mat-label>
                          <mat-select [formControl]="getCurrentPassPercentageControl()?.get('operator')"
                            (click)="handleMaterialClick($event)">
                            @for (op of passPercentageOperators; track op) {
                              <mat-option [value]="op.value"
                                (click)="handleMaterialClick($event)">
                                {{ op.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <!-- Single Value Range Input - HTML5 range use karo -->
                        @if (!isPassPercentageBetweenOperator()) {
                          <div class="mb-4" (click)="handleMaterialClick($event)">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <label class="form-control-label mb-0">Pass Percentage:</label>
                              <span class="percentage-badge">{{ getCurrentPassPercentageControl()?.get('value')?.value || 0
                              }}%</span>
                            </div>
                            <input type="range" class="form-range w-100" min="0" max="100" step="1"
                              [formControl]="getCurrentPassPercentageControl()?.get('value')">
                              <div class="d-flex justify-content-between mt-1">
                                <small class="text-muted">0%</small>
                                <small class="text-muted">100%</small>
                              </div>
                            </div>
                          }
                          @if (isPassPercentageBetweenOperator()) {
                            <div class="mb-3" (click)="handleMaterialClick($event)">
                              <div class="row">
                                <div class="col-6">
                                  <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="form-control-label mb-0">From:</label>
                                    <span class="percentage-badge">{{ getCurrentPassPercentageControl()?.get('start')?.value || 0
                                    }}%</span>
                                  </div>
                                  <input type="range" class="form-range w-100" min="0" max="100" step="1"
                                    [formControl]="getCurrentPassPercentageControl()?.get('start')">
                                  </div>
                                  <div class="col-6">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                      <label class="form-control-label mb-0">To:</label>
                                      <span class="percentage-badge">{{ getCurrentPassPercentageControl()?.get('end')?.value || 0
                                      }}%</span>
                                    </div>
                                    <input type="range" class="form-range w-100" min="0" max="100" step="1"
                                      [formControl]="getCurrentPassPercentageControl()?.get('end')">
                                    </div>
                                  </div>
                                  <div class="d-flex justify-content-between mt-1">
                                    <small class="text-muted">0%</small>
                                    <small class="text-muted">100%</small>
                                  </div>
                                </div>
                              }
                              <div class="mt-3">
                                <ng-template [ngTemplateOutlet]="Actions"
                                [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                              </div>
                            </form>
                          </div>
                        }
                        @case ('tat_days') {
                          <div class="p-2">
                            <form [formGroup]="filterForm" (click)="handleMaterialClick($event)">
                              <p class="mb-2"><strong>{{ selectedItem?.name || 'TAT Days Filter' }}</strong></p>
                              <mat-form-field appearance="outline" class="w-100 mb-3" (click)="handleMaterialClick($event)">
                                <mat-label>Operator</mat-label>
                                <mat-select [formControl]="getCurrentTatControl()?.get('operator')"
                                  (click)="handleMaterialClick($event)">
                                  @for (op of tatOperators; track op) {
                                    <mat-option [value]="op.value"
                                      (click)="handleMaterialClick($event)">
                                      {{ op.label }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                              @if (!isTatBetweenOperator()) {
                                <div class="mb-4" (click)="handleMaterialClick($event)">
                                  <label class="form-control-label d-block mb-2">TAT Days</label>
                                  <input type="number" class="form-control" min="0" placeholder="Enter TAT days"
                                    [formControl]="getCurrentTatControl()?.get('value')">
                                  </div>
                                }
                                @if (isTatBetweenOperator()) {
                                  <div class="mb-4" (click)="handleMaterialClick($event)">
                                    <div class="row">
                                      <div class="col-6">
                                        <label class="form-control-label d-block mb-2">From Days</label>
                                        <input type="number" class="form-control" min="0" placeholder="Min days"
                                          [formControl]="getCurrentTatControl()?.get('start')">
                                        </div>
                                        <div class="col-6">
                                          <label class="form-control-label d-block mb-2">To Days</label>
                                          <input type="number" class="form-control" min="0" placeholder="Max days"
                                            [formControl]="getCurrentTatControl()?.get('end')">
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    <div class="mt-3">
                                      <ng-template [ngTemplateOutlet]="Actions"
                                      [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                                    </div>
                                  </form>
                                </div>
                              }
                              @case ('amount') {
                                <div class="p-2">
                                  <form [formGroup]="filterForm" (click)="handleMaterialClick($event)">
                                    <p class="mb-2">{{ selectedItem?.name || 'Amount Filter' }}</p>
                                    <!-- Operator Selection -->
                                    <mat-form-field appearance="outline" class="w-100 mb-3" (click)="handleMaterialClick($event)">
                                      <mat-label>Operator</mat-label>
                                      <mat-select [formControl]="getCurrentAmountControl()?.get('operator')"
                                        (click)="handleMaterialClick($event)">
                                        @for (op of amountOperators; track op) {
                                          <mat-option [value]="op.value"
                                            (click)="handleMaterialClick($event)">
                                            {{ op.label }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                    <!-- Single Value Input -->
                                    @if (!isBetweenOperator()) {
                                      <div class="mb-3" (click)="handleMaterialClick($event)">
                                        <mat-form-field appearance="outline" class="w-100">
                                          <mat-label>Amount</mat-label>
                                          <input matInput type="number" [formControl]="getCurrentAmountControl()?.get('value')"
                                            placeholder="Enter amount" min="0" (click)="handleMaterialClick($event)" />
                                            <span matPrefix>₹&nbsp;</span>
                                          </mat-form-field>
                                        </div>
                                      }
                                      <!-- Range Inputs for Between Operator -->
                                      @if (isBetweenOperator()) {
                                        <div class="mb-3" (click)="handleMaterialClick($event)">
                                          <div class="row">
                                            <div class="col-6">
                                              <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>From Amount</mat-label>
                                                <input matInput type="number" [formControl]="getCurrentAmountControl()?.get('start')"
                                                  placeholder="Min" min="0" (click)="handleMaterialClick($event)" />
                                                  <span matPrefix>₹&nbsp;</span>
                                                </mat-form-field>
                                              </div>
                                              <div class="col-6">
                                                <mat-form-field appearance="outline" class="w-100">
                                                  <mat-label>To Amount</mat-label>
                                                  <input matInput type="number" [formControl]="getCurrentAmountControl()?.get('end')"
                                                    placeholder="Max" min="0" (click)="handleMaterialClick($event)" />
                                                    <span matPrefix>₹&nbsp;</span>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          <!-- Action Buttons -->
                                          <div class="mt-3">
                                            <ng-template [ngTemplateOutlet]="Actions"
                                            [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                                          </div>
                                        </form>
                                      </div>
                                    }
                                    @case ('list') {
                                      <div class="p-2">
                                        <form [formGroup]="filterForm">
                                          <p class="mb-2">{{ selectedItem?.name || 'Tags' }}</p>
                                          <!-- Key Value Add UI -->
                                          <div class="d-flex mb-2">
                                            <input class="form-control mr-1" formControlName="tagKey" placeholder="Key" />
                                            <input class="form-control ml-1" formControlName="tagValue" placeholder="Value" />
                                            <button mat-mini-fab type="button" color="primary" class="ml-2 add-tag-btn" (click)="addTagFilter()"
                                              [disabled]="!filterForm.get('tagKey')?.value || !filterForm.get('tagValue')?.value">
                                              <i class="fas fa-plus"></i>
                                            </button>
                                          </div>
                                          <!-- Currently Selected Tags -->
                                          <div formArrayName="tagFilters" class="d-flex flex-row flex-wrap mb-3">
                                            @for (group of tagFilters.controls; track group; let idx = $index) {
                                              <mat-chip class="mr-2 my-1 py-1 px-2"
                                                [formGroupName]="idx">
                                                {{ group.get('key')?.value }} : {{ group.get('value')?.value }}
                                                <i class="fas fa-times ml-1" style="cursor: pointer;" (click)="removeTagFilter(idx)">
                                                </i>
                                              </mat-chip>
                                            }
                                          </div>
                                          <!-- Action Buttons -->
                                          <ng-template [ngTemplateOutlet]="Actions" [ngTemplateOutletContext]="{ $implicit: selectedItem }">
                                          </ng-template>
                                        </form>
                                      </div>
                                    }
                                    @case ('status') {
                                      <div class="p-2">
                                        <form [formGroup]="filterForm">
                                          <p class="mb-2">{{ selectedItem?.name || 'Status' }}</p>
                                          <div class="list-box">
                                            @for (item of (selectedItem?.data || []); track item) {
                                              <div>
                                                <input type="checkbox" [value]="item" (change)="statusCheckboxHandler($event, item)"
                                                  [checked]="isStatusSelected(item)" />
                                                  <label class="form-control-label ml-2">{{ item }}</label>
                                                </div>
                                              }
                                              @if (!selectedItem?.data?.length) {
                                                <div class="text-muted">
                                                  No status options available
                                                </div>
                                              }
                                            </div>
                                            <div class="mt-3">
                                              <ng-template [ngTemplateOutlet]="Actions"
                                              [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                                            </div>
                                          </form>
                                        </div>
                                      }
                                      @case ('static') {
                                        <div class="p-2">
                                          <form [formGroup]="filterForm">
                                            <p class="mb-2">{{ selectedItem?.name || 'Static' }}</p>
                                            <div class="list-box">
                                              @for (item of (selectedItem?.data || []); track item) {
                                                <div class="d-flex align-items-start mb-1"
                                                  style="word-wrap: break-word; overflow-wrap: break-word;">
                                                  <input type="checkbox" [value]="item" (change)="staticCheckboxHandler($event, item)"
                                                    [checked]="isStaticSelected(item)" class="mt-1" />
                                                    <label class="form-control-label ml-2 text-wrap"
                                                    style="white-space: normal; word-break: break-word; line-height: 1.4;">{{ item }}</label>
                                                  </div>
                                                }
                                                @if (!selectedItem?.data?.length) {
                                                  <div class="text-muted">
                                                    No matching items
                                                  </div>
                                                }
                                              </div>
                                              <div class="mt-3">
                                                <ng-template [ngTemplateOutlet]="Actions"
                                                [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                                              </div>
                                            </form>
                                          </div>
                                        }
                                        @case ('number') {
                                          <div class="pl-2">
                                            <form [formGroup]="filterForm">
                                              <mat-radio-group aria-label="Select an option" class="d-flex flex-column mt-3 mb-5"
                                                formControlName="option">
                                                <mat-radio-button value="is">Is</mat-radio-button>
                                                @if (filterForm.value.option === 'is') {
                                                  <input type="number"
                                                    class="mb-2 ml-4 form-control form-control-alternative" placeholder="Value"
                                                    formControlName="isValue" />
                                                }
                                                <mat-radio-button value="between">Is Between</mat-radio-button>
                                                @if (filterForm.value.option === 'between') {
                                                  <div class="d-flex">
                                                    <input type="number" class="ml-4 w-50 form-control form-control-alternative" placeholder="Start"
                                                      formControlName="start" />
                                                      <input type="number" class="ml-1 w-50 form-control form-control-alternative" placeholder="End"
                                                        formControlName="end" />
                                                      </div>
                                                    }
                                                  </mat-radio-group>
                                                  <div class="mt-2">
                    <ng-template [ngTemplateOutlet]="Actions" [ngTemplateOutletContext]="{
                        $implicit: selectedItem
                      }"></ng-template>
                                                  </div>
                                                </form>
                                              </div>
                                            }
                                            @case ('text') {
                                              <div class="pl-2">
                                                <form [formGroup]="filterForm">
                                                  <mat-radio-group aria-label="Select an option" class="d-flex flex-column mt-3 mb-5"
                                                    formControlName="option">
                                                    <mat-radio-button value="is">Is</mat-radio-button>
                                                    @if (filterForm.value.option === 'is') {
                                                      <input type="text" class="form-control mt-2 mb-3"
                                                        formControlName="isValue" placeholder="Enter exact value">
                                                    }
                                                    <mat-radio-button value="contains">Contains</mat-radio-button>
                                                    @if (filterForm.value.option === 'contains') {
                                                      <input type="text" class="form-control mt-2"
                                                        formControlName="containsValue" placeholder="Enter partial value">
                                                    }
                                                  </mat-radio-group>
                                                  <div class="mt-2">
                                                    <ng-template [ngTemplateOutlet]="Actions"
                                                    [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                                                  </div>
                                                </form>
                                              </div>
                                            }
                                            @case ('date') {
                                              <div class="pl-2">
                                                <form [formGroup]="filterForm">
                                                  <mat-radio-group aria-label="Select an option" class="d-flex flex-column mt-3 mb-5"
                                                    formControlName="option">
                                                    <mat-radio-button value="is">Is</mat-radio-button>
                                                    @if (filterForm.value.option === 'is') {
                                                      <mat-form-field appearance="fill" class="mb-3 ml-3">
                                                        <mat-label>Choose a date</mat-label>
                                                        <input matInput [matDatepicker]="picker" formControlName="start" readonly />
                                                        <mat-hint>DD/MM/YYYY</mat-hint>
                                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                      </mat-form-field>
                                                    }
                                                    <mat-radio-button value="between">Is Between</mat-radio-button>
                                                    @if (filterForm.value.option === 'between') {
                                                      <mat-form-field appearance="fill" class="ml-3">
                                                        <mat-label>Enter a date range</mat-label>
                                                        <mat-date-range-input [rangePicker]="dateRangePicker">
                                                          <input matStartDate formControlName="start" placeholder="Start date" #dateRangeStart readonly />
                                                          <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd readonly />
                                                        </mat-date-range-input>
                                                        <mat-datepicker-toggle matPrefix [for]="dateRangePicker">
                                                        </mat-datepicker-toggle>
                                                        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                                                      </mat-form-field>
                                                    }
                                                  </mat-radio-group>
                                                  <div class="mt-2">
                    <ng-template [ngTemplateOutlet]="Actions" [ngTemplateOutletContext]="{
                        $implicit: selectedItem
                      }"></ng-template>
                                                  </div>
                                                </form>
                                              </div>
                                            }
                                            @case ('all') {
                                              <div class="p-2 mt-5">
                                                <p>Has any</p>
                                                <form [formGroup]="filterForm">
                                                  <input type="text" class="mb-5 form-control form-control-alternative" placeholder="Search"
                                                    formControlName="value" />
                                                  </form>
                                                  <ng-template [ngTemplateOutlet]="Actions"
                                                  [ngTemplateOutletContext]="{ $implicit: selectedItem }"></ng-template>
                                                </div>
                                              }
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>

                                <ng-template #Actions let-item>
                                  <div class="d-flex justify-content-between mt-2">
                                    <button mat-button (click)="clearFilter(item.type)">Clear</button>
                                    <button mat-button class="button-apply" type="submit" (click)="applyFilter(item.type, item.dataKeyName, item.name)"
                                      [disabled]="!isAnyFilterSelected()">
                                      Apply Filter
                                    </button>
                                  </div>
                                </ng-template>